import { render } from "./ProspectosDetallesView.vue?vue&type=template&id=2aef6f28&ts=true"
import script from "./ProspectosDetallesView.vue?vue&type=script&lang=ts"
export * from "./ProspectosDetallesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__